/* the modal has no header, so the illustration bleeds to its edges and fades into its surface */
.hero {
	position: relative;
	aspect-ratio: 2.75 / 1;
	margin: calc(var(--size-7) * -1) calc(var(--size-7) * -1) 0;
	background:
		url("../../../../machines.avif") center 85% / auto 80% no-repeat,
		linear-gradient(light-dark(var(--gray-500), var(--gray-700)), var(--color-surface));
}

.close {
	position: absolute;
	top: var(--size-4);
	right: var(--size-4);
}

.heading {
	display: flex;
	flex-direction: column;
	gap: var(--size-2);
}

.title {
	font-size: var(--text-title);
	font-weight: 600;
}

.blurb {
	color: var(--color-text-subtle);
	text-wrap: pretty;
}

.features {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: var(--size-4);

	@media (max-width: 539px) {
		grid-template-columns: 1fr;
	}
}

.feature {
	display: flex;
	flex-direction: column;
	gap: var(--size-2);
	padding: var(--size-5);
	border-radius: var(--radius-lg);
	background-color: light-dark(var(--gray-300), var(--gray-700));
}

.featureIcon {
	display: grid;
	place-content: center;
	width: var(--size-9);
	height: var(--size-9);
	margin-bottom: var(--size-2);
	border-radius: var(--radius-md);
	background-color: var(--color-primary-background);
	color: var(--color-primary-foreground);
}

.featureTitle {
	font-size: var(--text-body);
	font-weight: 600;
}

.featureText {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.links {
	display: flex;
	flex-direction: column;
	gap: var(--size-3);
}

.link {
	display: grid;
	grid-template-columns: 1fr auto;
	align-items: center;
	gap: var(--size-1) var(--size-5);
	padding: var(--size-4) var(--size-5);
	border-radius: var(--radius-lg);
	color: inherit;
	background-color: light-dark(var(--gray-300), var(--gray-700));
	transition: background-color 0.1s ease;

	&:where(:hover, :focus-visible) {
		text-decoration: none;
		background-color: light-dark(
			var(--gray-400),
			color-mix(in oklab, var(--gray-700), var(--gray-600) 30%)
		);
	}
}

.linkArrow {
	grid-column: 2;
	grid-row: 1 / span 2;
	display: flex;
	color: var(--color-text-subtle);
	transition: transform 0.1s ease;

	.link:where(:hover, :focus-visible) & {
		transform: translateX(var(--size-1));
	}
}

.confirm {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}
